import { render, staticRenderFns } from "./Update-Service-Form.vue?vue&type=template&id=764ef74f"
import script from "./Update-Service-Form.vue?vue&type=script&lang=js"
export * from "./Update-Service-Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports